import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const MainBlock = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.colors.Scrim};
  z-index: ${theme.zIndex.modal};
  animation: ${fadeIn} 0.2s ease-out;
`;

/**
 * Ширина окна задаётся пропом `size` у `UDModal`, а не классами у содержимого.
 * Без `size` окно получает `md` — фиксированную ширину, а не ширину по контенту:
 * иначе окно расползается от длины текста внутри.
 */
export const MODAL_WIDTHS = {
  sm: 440,
  md: 560,
  lg: 760,
} as const;

export const ModalContainer = styled.div<{ $width?: number; $height?: number }>`
  position: relative;
  display: flex;
  flex-direction: column;
  ${({ $width }) => ($width ? `width: ${$width}px;` : '')}
  ${({ $height }) => ($height ? `height: ${$height}px;` : '')}
  background: white;
  border: 1px solid ${theme.colors.LineSubtle};
  border-radius: ${({ theme }) => theme.radii.panel};
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
  animation: ${slideIn} 0.3s ease-out;

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
  }

  @media (max-width: 768px) {
    max-width: 100vw;
  }
`;
